module.exports = __webpack_public_path__ + "img/Vector1.0df4fbd5.svg";